import {} from './BlockchainAdapter.types'
import MetamaskAdapter from './MetamaskAdapter'
// import WalletConnectAdapter from "./WalletConnectAdapter";
import WalletConnectAdapter from './WalletConnectAdapter'
import MultiversXAdapter from './MultiversXAdapter'

export function createBlockchainAdapter(chain: string): {
  [key: string]: any
} {
  switch (chain) {
    case 'ETHEREUM':
      return {
        metamask: new MetamaskAdapter(),
        walletConnect: new WalletConnectAdapter(),
      }
    case 'BNB':
      return {
        metamask: new MetamaskAdapter(),
        walletConnect: new WalletConnectAdapter(),
      }
    case 'POLYGON':
      return {
        metamask: new MetamaskAdapter(),
        walletConnect: new WalletConnectAdapter(),
      }
    case 'MULTIVERSX':
      return { multiversx: new MultiversXAdapter() }
    // ... other cases
    default:
      return { default: '' }
  }
}
